import { checkElementInView } from './checkElementInView';
// eslint-disable-next-line no-unused-vars
//import { checkVidTest } from './checkVidTest';

const primarySectionSelectors = '#page > .content-wrapper > *';
const primarySections = document.querySelectorAll(primarySectionSelectors);
const secondarySectionSelectors =
	'#page > .content-wrapper > * > *:not(.lightbox):not(.no-animation), #page .content-wrapper .content-wrapper > *:not(.lightbox):not(.no-animation), .animate-in';
const secondarySections = document.querySelectorAll(secondarySectionSelectors);
const header = document.querySelector('.main-header');
const top = document.getElementById('top');

const mediaZoomContainerJIM = document.querySelector('.block-media-zoom');

let observer1;
let observer2;
// eslint-disable-next-line no-unused-vars
let observer3;
// eslint-disable-next-line no-unused-vars
let observer4;
// eslint-disable-next-line no-unused-vars
let observer5;
// eslint-disable-next-line no-unused-vars
//let observer6;
// eslint-disable-next-line no-unused-vars
let observer7;
// eslint-disable-next-line no-unused-vars
let observer8;
// eslint-disable-next-line no-unused-vars
//let observer9;

// const optionsWHAT = {
// 	root: null,
// 	rootMargin: '0px',
// 	threshold: 0.5,
// };

//const targetElementWHAT = document.querySelector('.block-media-zoom');
//const imageWHAT = document.querySelector('.block-media-zoom img');
// eslint-disable-next-line no-unused-vars
// const observer9 = new IntersectionObserver((entries) => {
// 	entries.forEach((entry) => {
// 		// Update the variable with the intersection ratio
// 		const amountInView = entry.intersectionRatio;
// 		// eslint-disable-next-line no-console
// 		console.log(`Amount in view: ${amountInView}`);

// 		//const intersectionRatio = entry.intersectionRatio;

// 		// Gradually increase or decrease the size based on the intersection ratio
// 		//const scaleFactor = 1 + (0.5 - intersectionRatio); // Adjust the scale factor as needed

// 		const scrollPosition = window.scrollY;
// 		// eslint-disable-next-line no-console
// 		console.log(`scrollPosition: ${scrollPosition}`);
// 		//const scaleFactor = 1 + scrollPosition * 0.0005; // Adjust the multiplier as needed
// 		const scaleFactor = 1 + scrollPosition * 0.0003; // Adjust the multiplier as needed

// 		imageWHAT.style.transform = `scale(${scaleFactor})`;
// 		//imageWHAT.style.width = `${scaleFactor}`;
// 		imageWHAT.style.setProperty('--width', `var(--${scaleFactor})`);
// 	});
// });

// Create an Intersection Observer with the callback and options
//const observer9 = new IntersectionObserver(handleIntersection, optionsWHAT); //sectionsInView.js:59 Uncaught TypeError: Failed to construct 'IntersectionObserver': parameter 1 is not of type 'Function'.

// Start observing the target element
//observer9.observe(imageWHAT);

//moved mediaZoom

// const mediaZoomContainerNEWEST = document.querySelectorAll(
// 	'.media-zoom-container'
// );
// const mediaZoomImageNEWEST = document.querySelectorAll(
// 	'.media-zoom-container figure'
// );

// eslint-disable-next-line no-unused-vars
//let observer6;

// Options for the Intersection Observer
// const mediaZoomOptionsNEWEST = {
// 	root: null,
// 	rootMargin: '0px',
// 	threshold: 0.5,
// };

//moved this observer section to header.js

// Create an Intersection Observer with the callback and options
// const observer6 = new IntersectionObserver( //sectionsInView.js:48 Uncaught TypeError: Failed to construct 'IntersectionObserver': parameter 1 is not of type 'Function'.
// 	handleIntersection,
// 	mediaZoomOptionsNEWEST
// );

// Start observing the target element
// observer6.observe(mediaZoomContainerNEWEST);

// Callback function to handle the intersection changes
// eslint-disable-next-line no-unused-vars, no-shadow
// const handleIntersection = (entries, observer6) => {
// 	entries.forEach((entry) => {
// 		const intersectionRatio = entry.intersectionRatio;

// 		document.body.classList.add('mediaZoom');

// 		// Gradually increase or decrease the size based on the intersection ratio
// 		const scaleFactor = 1 + (0.5 - intersectionRatio); // Adjust the scale factor as needed

// 		mediaZoomImageNEWEST.style.transform = `scale(${scaleFactor})`;
// 	});
// };

// eslint-disable-next-line no-unused-vars
const specificVideoTarget = document.getElementById('closingTheLoopMP4');
const verticalIntegrationVideo = document.getElementById(
	'verticalIntegrationMP4'
);
const mediaZoomTargetJIM = document.getElementById('mediaZoomTarget');
// const mediaZoomContainerFINALLY = document.querySelectorAll(
// 	'.media-zoom-container'
// );
// const mediaZoomImageFINALLY = document.querySelectorAll(
// 	'.media-zoom-container figure'
// );

// const videoAutoPlays = document.querySelectorAll('video');
// if (videoAutoPlays.length) {
// 	newThingLinks(videoAutoPlays);
// }

// eslint-disable-next-line no-console
//console.log('jms-test');

const sectionsInView = () => {
	if (header && primarySections.length) {
		// eslint-disable-next-line no-undef
		observer1 = checkElementInView(
			primarySectionSelectors,
			primarySectionInView,
			sectionOut,
			{
				root: null,
				rootMargin: `0px 0px -${window.innerHeight - 68}px 0px`,
				threshold: [0],
			}
		);
	}

	if (secondarySections.length) {
		observer2 = checkElementInView(
			secondarySectionSelectors,
			secondarySectionInView,
			sectionOut,
			{
				root: null,
				rootMargin: '0px 0px -20% 0px',
				threshold: [0],
			}
		);
	}

	if (top) {
		observer3 = checkElementInView(top, topSectionInView, topSectionOut, {
			root: null,
			rootMargin: '0px 0px 0px 0px',
			threshold: [0],
		});
	}

	if (specificVideoTarget) {
		observer4 = checkElementInView(
			specificVideoTarget,
			targetVidInView,
			targetVidOutView,
			{
				root: null,
				rootMargin: '0px 0px 0px 0px',
				threshold: [0],
			}
		);
	}
	if (verticalIntegrationVideo) {
		observer5 = checkElementInView(
			verticalIntegrationVideo,
			targetVidInView,
			targetVidOutView,
			{
				root: null,
				rootMargin: '0px 0px 0px 0px',
				threshold: [0],
			}
		);
	}
	if (mediaZoomTargetJIM) {
		observer8 = checkElementInView(
			//mediaZoomContainerInViewJIM,
			mediaZoomTargetJIM,
			mediaZoomInViewJIM,
			mediaZoomOutJIM,
			{
				root: null,
				rootMargin: '0px 0px 0px 0px',
				threshold: [0],
			}
		);
	}
	// if (mediaZoomContainerFINALLY) {
	// 	observer7 = checkElementInView(
	// 		mediaZoomContainerFINALLY,
	// 		mediaZoomInViewFINALLY,
	// 		mediaZoomOutViewFINALLY,
	// 		{
	// 			root: null,
	// 			rootMargin: '0px 0px 0px 0px',
	// 			threshold: [0],
	// 		}
	// 	);
	// }
};

// eslint-disable-next-line no-unused-vars
const primarySectionInView = (e) => {
	if (
		e.hasAttribute('data-bg') &&
		!document.body.classList.contains('smoothScrolling')
	) {
		setHeaderColors(e);
	}
};

// eslint-disable-next-line no-unused-vars
const mediaZoomContainerInViewJIM = (e) => {
	setMediaZoomJIM(e);
};

// eslint-disable-next-line no-unused-vars
const sectionOut = (e) => {};

const secondarySectionInView = (e) => {
	e.classList.add('in-viewport');
};

// eslint-disable-next-line no-unused-vars
const topSectionInView = (e) => {
	//setHeaderColors('transparent');
	document.body.classList.add('topSectionInView');
};

// eslint-disable-next-line no-unused-vars
const topSectionOut = (e) => {
	//setHeaderColors('black');
	document.body.classList.remove('topSectionInView');
};

// eslint-disable-next-line no-unused-vars
const targetVidInView = (e) => {
	document.body.classList.add('vidAutoPlay');
	if (specificVideoTarget) {
		specificVideoTarget.muted = true;
		specificVideoTarget.play();
	}
	if (verticalIntegrationVideo) {
		verticalIntegrationVideo.muted = true;
		verticalIntegrationVideo.play();
	}
};

// eslint-disable-next-line no-unused-vars
const mediaZoomInViewJIM = (e) => {
	setMediaZoomJIM(e);
	document.body.classList.add('mediaZoomJIM');

	// eslint-disable-next-line no-unused-vars
};

// eslint-disable-next-line no-unused-vars
const mediaZoomOutJIM = (e) => {
	document.body.classList.remove('mediaZoomJIM');
};

// eslint-disable-next-line no-unused-vars
//const mediaZoomInViewFINALLY = (e) => {
// eslint-disable-next-line no-unused-expressions
//mediaZoomFunctionFINALLY;

// document.body.classList.add('media-zoom-FINALLY');
// const intersectionRatio = intersectionRatio;
// const scaleFactor = 1 + (0.5 - intersectionRatio); // Adjust the scale factor as needed
// mediaZoomImageFINALLY.style.color = 'red';

//mediaZoomImageFINALLY.style.transform = `scale(${scaleFactor})`; //Cannot set properties of undefined (setting 'transform')
// mediaZoomImageFINALLY.style.setProperty(
// 	'--transform',
// 	`--scale(${scaleFactor})`
// );
//sectionsInView.js:210 Uncaught TypeError: Cannot read properties of undefined (reading 'setProperty')
// second.style.transform = `rotate(${secDegree}deg)`;
// second.innerText = secDegree;

// specificVideoTarget.muted = true;
// specificVideoTarget.play();
// verticalIntegrationVideo.muted = true;
// verticalIntegrationVideo.play();

// Callback function to handle the intersection changes
// const handleIntersection = (entries, observer) => {
// entries.forEach((entry) => {
// 	const intersectionRatio = entry.intersectionRatio;

// 	// Gradually increase or decrease the size based on the intersection ratio
// 	const scaleFactor = 1 + (0.5 - intersectionRatio); // Adjust the scale factor as needed

// 	image.style.transform = `scale(${scaleFactor})`;
// });
// };
//};

// eslint-disable-next-line no-unused-vars
const targetVidOutView = (e) => {
	document.body.classList.remove('vidAutoPlay');
};

// eslint-disable-next-line no-unused-vars
// const mediaZoomOutViewFINALLY = (e) => {
// 	document.body.classList.remove('media-zoom-FINALLY');
// };

const setHeaderColors = (section) => {
	let backgroundColor;
	let textColor;

	if ('string' === typeof section) {
		backgroundColor = section;
		textColor = 'white';
	} else {
		backgroundColor = section.getAttribute('data-bg');
		textColor = 'white';
	}

	if ('white' === backgroundColor || 'transparent' === backgroundColor) {
		textColor = 'black';
	}

	if (
		'transparent' === backgroundColor &&
		document.body.classList.contains('smoothScrolling')
	) {
		backgroundColor = 'black';

		setTimeout(function () {
			//header.style.setProperty('--backgroundColor', `var(--transparent)`); check - jms
			//document.body.classList.toggle(`${backgroundColor}`);
			//document.body.classList.remove('vidAutoPlay');
		}, 600);
	}

	header.style.setProperty('--backgroundColor', `var(--${backgroundColor})`);
	//document.body.classList.toggle(`${backgroundColor}`);

	header.style.setProperty('--textColor', `var(--${textColor})`);
	//document.body.classList.toggle(`${textColor}`);
};

const setMediaZoomJIM = (section) => {
	let backgroundColor;
	let textColor;
	const intersectionRatio = intersectionRatio;

	if ('string' === typeof section) {
		backgroundColor = section;
		textColor = 'white';
	} else {
		backgroundColor = section.getAttribute('data-bg');
		textColor = 'white';
	}
	// eslint-disable-next-line no-undef
	// sections.forEach((section) => {
	// 	// Update the variable with the intersection ratio
	// 	const amountInView = section.intersectionRatio;
	// 	// eslint-disable-next-line no-console
	// 	console.log(`Amount in view: ${amountInView}`);
	// });

	// Gradually increase or decrease the size based on the intersection ratio
	const scaleFactor = 1 + (0.5 - intersectionRatio); // Adjust the scale factor as needed

	//mediaZoomContainerJIM.style.transform = `scale(${scaleFactor})`;
	mediaZoomContainerJIM.style.setProperty(
		'--transform',
		`var(--${scaleFactor})`
	);

	mediaZoomContainerJIM.style.setProperty(
		'--backgroundColor',
		`var(--${backgroundColor})`
	);
	mediaZoomContainerJIM.style.setProperty(
		'--textColor',
		`var(--${textColor})`
	);
};

// eslint-disable-next-line no-shadow
// eslint-disable-next-line no-unused-vars
//const mediaZoomFunctionFINALLY = () => {
// document.body.classList.add('media-zoom-FINALLYYYYYYYY');
// const intersectionRatio = intersectionRatio;
//const scaleFactor = 1 + (0.5 - intersectionRatio); // Adjust the scale factor as needed
//mediaZoomImageFINALLY.style.color = 'red';
//figure.style.color = 'red';

//mediaZoomImageFINALLY.style.transform = `scale(${scaleFactor})`; //Cannot set properties of undefined (setting 'transform')
// mediaZoomImageFINALLY.style.setProperty(
// 	'--transform',
// 	`--scale(${scaleFactor})`
// );
//};

// const newThingLinks = (videoAutoPlays) => {
// 	videoAutoPlays.forEach((videoAutoPlay) => {
// 		//anchorLink.addEventListener('click', clickAnchorLink);

// 		// eslint-disable-next-line no-console
// 		console.log(videoAutoPlay.isIntersecting);

// 		//const selectorNew = document.querySelector('#testVid');
// 		//const selectorNew = document.getElementById('testVid');
// 		//const sectionNew = document.querySelector(selectorNew);

// 		// if (sectionNew) {
// 		// 	observer = checkElementInView(
// 		// 		[sectionNew],
// 		// 		sectionInView,
// 		// 		sectionOutOfView,
// 		// 		{
// 		// 			root: null,
// 		// 			rootMargin: `0px 0px -${window.innerHeight - 68}px 0px`,
// 		// 			threshold: [0],
// 		// 		}
// 		// 	);
// 		// }
// 	});
// };

const resetObservers = () => {
	if ('object' === typeof observer1) {
		observer1.disconnect();
	}

	if ('object' === typeof observer2) {
		observer2.disconnect();
	}

	sectionsInView();
};

export {
	sectionsInView,
	setHeaderColors,
	setMediaZoomJIM,
	//mediaZoomFunctionFINALLY,
	resetObservers,
};
